import Typography from '@/ui/components/typography'
import { TTheme } from '@core/theme'
import { styled } from '@mui/system'

export const Title = styled(Typography)`
    color: var(--color-greys-400);
`

export const NoRelatedCases = styled(Typography)`
    margin-top: 12px;
    color: var(--color-greys-600);
`

export const Content = styled('div')`
    width: 100%;
    padding: 22px 0;
`

export const Flex = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
    align-content: center;
`
export const Circle = styled('div')<{ width?: string; theme?: TTheme }>`
    display: flex;
    align-self: center;
    background-color: ${({ theme }) => `${theme.colors.greys[200]}`};
    width: ${({ width }) => `${width || '5px'}`};
    aspect-ratio: 1;
    border-radius: 50%;
`
export const Status = styled('div')<{ value: string; theme?: TTheme }>`
    color: ${({ value, theme }) =>
        value === 'New' || value === 'Open'
            ? `${theme.colors.semantic.success}`
            : value === 'Closed'
              ? `${theme.colors.semantic.success}`
              : `${theme.colors.primary[900]}`};
`
